/************************
 * All the functions needed in the careers subdomain
 *************************/

import { TFunction } from "i18next";
import { CareersJob, TCareerDomain, TCareerSalaryPeriod } from "../../types/db";
import { currencyFormatter } from "../currency/function";

/**
 * Get the localized label for the given domain
 * @param t The translation function
 * @param domain the career domain
 * @returns the localized career domain
 */
export const getDomainLabelFrom = (t: TFunction, domain: TCareerDomain | string) => {
    switch (domain) {
        case "it":
            return t('careers.domain.it');
        case "sales-marketing":
            return t('careers.domain.marketing');
        case 'finance-accounting':
            return t('careers.domain.finance');
        // case 'health':
        // return t('careers.domain.health');
        case 'engineering':
            return t('careers.domain.engineering');
        case 'support':
            return t('careers.domain.support');
        // case 'training':
        // return t('careers.domain.training');
        case 'hr':
            return t('careers.domain.hr');
        // case 'manufacturing':
        // return t('careers.domain.manufacturing');
        case "RnD":
            return t('careers.domain.rnd');
        case 'design':
            return t('careers.domain.design');
        case 'legal':
            return t('careers.domain.legal');
        case 'retail-hospitality':
            return t('careers.domain.retail');
        case 'management':
            return t('careers.domain.management');
        case 'consulting-strategy':
            return t('careers.domain.consulting');
        // case 'services':
        // return t('careers.domain.services');
        // case 'administration':
        // return t('careers.domain.administration');
        case 'media-communication':
            return t('careers.domain.media');
        // case 'environment':
        // return t('careers.domain.environment');
        case 'others':
        default:
            return t('careers.domain.other');
    }
}

/**
 * Get the localized label for the given salary period
 * @param t The Translation function
 * @param period The salaray period
 * @returns the localized salary period
 * TODO: currently using it as is, but might need to be localized in the future
 */
export const getSalaryPeriodLabelFrom = (t: TFunction, period: TCareerSalaryPeriod) => {
    switch (period) {
        default:
            return period;
    }
}

/**
 * Get the formatted string for the salary for a given job
 * @param job The job data
 * @returns the formatted salary
 */
export const formatSalaryDisplay = (job: Pick<CareersJob, 'salary_range' | 'salary_currency' | 'salary_period'>, t: TFunction) => {
    if (job.salary_range[0] === job.salary_range[1]) {
        //if the salary min and max is the same
        return currencyFormatter({ quantity: job.salary_range[0], currency: job.salary_currency })
            + " (" + getSalaryPeriodLabelFrom(t, job.salary_period) + ")"
    }
    return job.salary_range
        .map((salary) => currencyFormatter({ quantity: salary, currency: job.salary_currency }))
        .join(' - ')
        + " (" + getSalaryPeriodLabelFrom(t, job.salary_period) + ")"
}

/** Map the data from backend to the screen UI */
export const mapDataToUI = (data: CareersJob, t: TFunction) => {
    return {
        title: data.title,
        subTitle: getDomainLabelFrom(t, data.domain),
        description: data.description,
        applicationDeadline: data.application_deadline?.toDate().toDateString() || '',
        jobType: data.type.join(', '),
        location: data.location,
        isRemote: data.is_remote,
        numberPosition: data.number_position?.toString() || '',
        salary: formatSalaryDisplay(data, t),
        keyResponsibilities: data.key_responsibilities,
        keyKnowledge: data.key_knowledge,
        keySkills: data.key_skills,
        benefits: data.key_benefits,
        process: data.processes,
        travelRequirement: data.travel_requirement?.includes("None") ? undefined : data.travel_requirement
    }
}